import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=66d00212&scoped=true&"
var script = {}
import style0 from "./Popover.vue?vue&type=style&index=0&id=66d00212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d00212",
  null
  
)

export default component.exports